import { client } from '../apiClient';
import { CreateLookerStudioReportModel } from '../../models/integrations/LookerStudioModel';
import { CreateReportResponse } from '../../models/integrations/LookerStudioResponse';

const LOOKER_STUDIO_ENDPOINT = '/looker-studio';
const PERIODIC_REPORTS_ENDPOINT = '/periodic-reports';

export class LookerStudioService {
  static async connect(authCode: string): Promise<boolean> {
    try {
      const response = await client(true, true).post(`${LOOKER_STUDIO_ENDPOINT}/connect`, { authCode });
      return response.status === 200;
    } catch (error) {
      console.error('Error connecting to Looker Studio:', error);
      return false;
    }
  }

  static async createReport(model: CreateLookerStudioReportModel): Promise<CreateReportResponse> {
    // Transform to PeriodicReport format
    const periodicReportData = {
      projectId: model.projectId,
      provider: 'LOOKER_STUDIO',
      type: 'DAILY',
      config: {
        parameters: {
          reportName: model.reportName,
          startDate: model.startDate,
          endDate: model.endDate,
          period: model.period,
          ...(model.templateReportId && { templateReportId: model.templateReportId }),
          ...(model.sheetName && { sheetName: model.sheetName })
        }
      },
      schedule: {
        hour: 9,
        timezone: 'UTC'
      },
      status: 'ACTIVE'
    };

    const response = await client(true, true).post(`${PERIODIC_REPORTS_ENDPOINT}/create`, periodicReportData);
    return response.data;
  }

  static async getConnectionStatus(): Promise<{ isConnected: boolean; reportId?: string }> {
    const response = await client(true, true).get(`${LOOKER_STUDIO_ENDPOINT}/connection-status`);
    return response.data;
  }

  static async disconnect(): Promise<boolean> {
    try {
      const response = await client(true, true).post(`${LOOKER_STUDIO_ENDPOINT}/disconnect`);
      return response.status === 200;
    } catch (error) {
      console.error('Error disconnecting:', error);
      return false;
    }
  }

  static async getReportUrl(reportId: number): Promise<{ url: string; status: 'create' | 'exists' }> {
    const response = await client(true, true).post(`${LOOKER_STUDIO_ENDPOINT}/get-report-url`, { reportId });
    return response.data;
  }

  static async saveFinalReportUrl(reportId: number, finalReportUrl: string): Promise<boolean> {
    try {
      const response = await client(true, true).post(`${LOOKER_STUDIO_ENDPOINT}/save-final-url`, { 
        reportId, 
        finalReportUrl 
      });
      return response.status === 200;
    } catch (error) {
      console.error('Error saving final report URL:', error);
      return false;
    }
  }
}
